var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import classNames from "classnames";
import generateID from "../../../utils/string-utils";
import "./styles.css";
import validator from "validator";
var SubscriptionForm = function (props) {
    // @ts-ignore
    var children = props.children, errorHint = props.errorHint, description = props.description, placeholder = props.placeholder, title = props.title, labelText = props.labelText, 
    // @ts-ignore
    __TYPE = props.__TYPE, hintText = props.hintText, id = props.id, remainingProps = __rest(props, ["children", "errorHint", "description", "placeholder", "title", "labelText", "__TYPE", "hintText", "id"]);
    var inputId = useRef(id || generateID());
    var hintId = useRef(generateID());
    var _a = useState(""), validEmail = _a[0], setValidEmail = _a[1];
    var _b = useState(false), emailError = _b[0], setEmailError = _b[1];
    var validateEmail = function (e) {
        var email = e.target.value;
        if (validator.isEmail(email)) {
            setValidEmail(email);
            setEmailError(false);
        }
        else {
            setEmailError(true);
        }
    };
    var handleClick = function () {
        window.location.href = "mailto:".concat(validEmail);
    };
    var _className = classNames("fr-input");
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "fr-follow__newsletter" },
            React.createElement("div", null,
                React.createElement("h5", { className: "fr-h5 fr-follow__title" }, title),
                React.createElement("p", { className: "fr-text--sm fr-follow__desc" }, description),
                React.createElement("form", { action: "" },
                    React.createElement("label", { className: "fr-label", htmlFor: inputId.current, "aria-describedby": hintId.current }, labelText),
                    React.createElement("div", { className: "fr-input-wrap fr-input-wrap--addon" },
                        React.createElement("input", __assign({ type: "text" }, remainingProps, { className: _className, id: inputId.current, placeholder: placeholder, onChange: function (e) { return validateEmail(e); } })),
                        React.createElement("button", { className: "fr-btn", id: hintId.current, onClick: handleClick, title: "S\u2018abonner \u00E0 notre lettre d\u2019information" }, "S'abonner")),
                    emailError && (React.createElement("p", { id: hintId.current, className: "fr-error-text" }, errorHint)),
                    React.createElement("p", { id: hintId.current, className: "fr-hint-text" }, hintText)),
                children))));
};
SubscriptionForm.defaultProps = { __TYPE: "SubscriptionForm" };
SubscriptionForm.propTypes = { __TYPE: PropTypes.string };
export default SubscriptionForm;
